import axios from 'axios';
import {BehaviorSubject} from 'rxjs';
// import Keycloak from "keycloak-js";
//
// const keycloak = new Keycloak(
//   {
//       url: "http://dockerdev01:8080/auth",
//       clientId: "webavailbackend",
//       realm: "3points"
//   }
// )


// const API_URL = 'http://localhost:8082';
// const API_URL = '/api/avail';
const API_URL = '';
const currentUserSubject = new BehaviorSubject(JSON.parse(localStorage.getItem('currentUser')));

// const config = {
//     headers: {
//         'Content-Type': 'application/json'
//     }
// }


class UserService {
    get currentUserValue() {
        return currentUserSubject.value;
    }

    get currentUser() {
        return currentUserSubject.asObservable();
    }

    login(user) {
        let formData = new FormData();

        formData.set('username', user.username);
        formData.set('password', user.password);

        // return axios({
        //     method: 'post',
        //     url: API_URL + '/auth/login',
        //     data: {username: user.username, password: user.password},
        //     headers: {'Content-Type': 'application/json'}
        // });

        return axios({
          method: 'post',
          // url: API_URL + '/auth/login',
          url: API_URL + '/api/login',
          data: formData,
          headers: {'Content-Type': 'multipart/form-data'}
        }).then(response => {
            user.password = '';
            localStorage.setItem('currentUser', JSON.stringify(user));
            currentUserSubject.next(user);
            console.log(response.data);
        })
    }

    keycloakLogin(user) {
        let params = new URLSearchParams();

        params.append('grant_type', 'password');
        params.append('client_id', 'webavailbackend');
        params.append('username', user.username);
        params.append('password', user.password);
        // return axios.post('http://dockerdev01:8080/auth/realms/3points/protocol/openid-connect/token', params);
        return axios.post('https://keycloak.intern.3p.local/auth/realms/3points/protocol/openid-connect/token', params);
    }

    logOut() {
        return axios.get(API_URL + '/auth/logout', {});
        // return axios.get(API_URL + '/logout', {}).then(() => {
        //     localStorage.removeItem('currentUser');
        //     currentUserSubject.next(null);
        // });
    }

}

export default new UserService();
